import { IconProps } from '@mui/material';
import React from 'react';

import { AddonCrown16, AddonCrown32 } from '@/assets/addons';

import { useCreateCustomIcon } from './duck';
import { LogoFnl2cHorz, LogoFnlWordBlack, LogoMark2c } from './logo';

export const LogoMark2cIconC: React.FC<IconProps> = ({
  ...props
}) => {
  /** Note: use 'sx' for <Icon> & 'style' for <img> */
  return useCreateCustomIcon(LogoMark2c, props);
};

export const LogoFnl2cHorzC: React.FC<IconProps> = ({
  ...props
}) => {
  /** Note: use 'sx' for <Icon> & 'style' for <img> */
  return useCreateCustomIcon(LogoFnl2cHorz, props);
};

export const LogoFnlWordBlackC: React.FC<IconProps> = ({
  ...props
}) => {
  /** Note: use 'sx' for <Icon> & 'style' for <img> */
  return useCreateCustomIcon(LogoFnlWordBlack, props);
};

export const AddonCrown16C: React.FC<IconProps> = ({
  ...props
}) => {
  /** Note: use 'sx' for <Icon> & 'style' for <img> */
  return useCreateCustomIcon(AddonCrown16, props);
};

export const AddonCrown32C: React.FC<IconProps> = ({
  ...props
}) => {
  /** Note: use 'sx' for <Icon> & 'style' for <img> */
  return useCreateCustomIcon(AddonCrown32, props);
};